import {put, takeEvery} from "redux-saga/effects";
import {ItemSpecificationModel} from "../../../Models/ItemSpecification";
import {fillItems} from "../../utils";
import {
    itemSpecificationCreateError,
    itemSpecificationCreateSuccess,
    itemSpecificationLoadError,
    itemSpecificationLoadSuccess,
    itemSpecificationsGetError,
    itemSpecificationsGetSuccess,
    itemSpecificationUpdateError,
    itemSpecificationUpdateSuccess,
} from "./actions";
import * as TYPES from "./types";

export default function* itemSpecificationsSagas() {
    yield takeEvery(TYPES.ITEM_SPECIFICATIONS_GET_REQUEST, itemSpecificationsGetRequest);
    yield takeEvery(TYPES.ITEM_SPECIFICATION_LOAD_REQUEST, itemSpecificationLoadRequest);
    yield takeEvery(TYPES.ITEM_SPECIFICATION_CREATE_REQUEST, itemSpecificationCreateRequest);
    yield takeEvery(TYPES.ITEM_SPECIFICATION_UPDATE_REQUEST, itemSpecificationUpdateRequest);
}

function* itemSpecificationsGetRequest(action) {
    try {
        const response = yield ItemSpecificationModel.index({
            ...action.payload,
        });

        yield put(
            itemSpecificationsGetSuccess({
                ...fillItems(response, ItemSpecificationModel),
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(itemSpecificationsGetError(error));
    }
}

function* itemSpecificationLoadRequest(action) {
    try {
        const response = yield ItemSpecificationModel.find(action.payload);

        yield put(
            itemSpecificationLoadSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(itemSpecificationLoadError(error));
    }
}

function* itemSpecificationCreateRequest(action) {
    try {
        const response = yield ItemSpecificationModel.create(action.payload);

        yield put(
            itemSpecificationCreateSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(itemSpecificationCreateError(error));
    }
}

function* itemSpecificationUpdateRequest(action) {
    try {
        const response = yield ItemSpecificationModel.update(action.payload.id, action.payload);

        yield put(
            itemSpecificationUpdateSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(itemSpecificationUpdateError(error));
    }
}
